// src/components/ConsultationManager.js
import React, { useState } from 'react';
import styles from './ConsultationManager.module.css';
import ConsultationForm from './ConsultationForm';
import ConsultationList from './ConsultationList';
import { useTranslation } from 'react-i18next';

function ConsultationManager({ isSidebarOpen }) {
  const { t } = useTranslation();
  const [view, setView] = useState('list'); // 'list' ou 'new'

  return (
    <div className={`${styles.consultationManager} ${!isSidebarOpen ? styles.adjustedForClosedSidebar : ''}`}>
      {/* O TÍTULO AGORA ESTÁ EM UM FLEX CONTAINER COM UM SPACER */}
      <div className={styles.consultationHeader}>
        <h2 className={styles.consultationManagerTitle}>{t('consultationManager')}</h2>
        {/* Este spacer invisível força o título para a esquerda, alinhando-o com o título do Chat */}
        <div className={styles.headerSpacer}></div>
      </div>
      <div className={styles.consultationManagerNavButtons}>
        <button
          className={`${styles.navButton} ${view === 'list' ? styles.navButtonActive : ''}`}
          onClick={() => setView('list')}
        >
          {t('savedConsultations')}
        </button>
        <button
          className={`${styles.navButton} ${view === 'new' ? styles.navButtonActive : ''}`}
          onClick={() => setView('new')}
        >
          {t('newConsultation')}
        </button>
      </div>
      <div className={styles.contentArea}>
        {view === 'list' ? <ConsultationList /> : <ConsultationForm />}
      </div>
    </div>
  );
}

export default ConsultationManager;